// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuList_root__oJbQR","withScroll":"MenuList_withScroll__OGtpJ","divider":"MenuList_divider__PrVCZ"};